<template>
  <div class="header-actions__wrapper">
    <client-only>
      <div v-if="isLoggedIn" class="header-actions__element">
        <slot
          name="notification-icon"
          :notification-count="newNotificationCount"
        >
          <a-notification-icon-with-modal-widget
            :notification-count="newNotificationCount"
            class="header-actions__action-item"
          />
        </slot>
      </div>
    </client-only>

    <div
      class="header-actions__element header-actions__element_sign-btn"
      :data-ref="$options.consts.REFS.LOGIN_ICON_WRAPPER"
    >
      <slot
        v-if="isUserIconVisible"
        name="user-icon"
        :id="$options.consts.ACTIVATOR_ID.AUTH"
      >
        <a-user-icon-with-modal-widget
          :id="$options.consts.ACTIVATOR_ID.AUTH"
          class="header-actions__avatar header-actions__action-item"
        />
      </slot>

      <slot v-else name="sign-in-btn">
        <a-login-button
          class="header-actions__action-item header-actions__sign-btn"
        />
      </slot>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AUserIconWithModalWidget from '@/components/AHeader/Shared/AUserIconWithModalWidget/index.vue'
import ANotificationIconWithModalWidget from '@/components/AHeader/Shared/AHeaderActions/ANotificationIconWithModalWidget/index'
import { FM_ROUTE, ROUTE } from 'enums/routes'
import { BUTTON_STYLE } from 'shared/AButton/index'
import mixins from '@/utils/mixins'
import { REFS } from 'enums/external-refs'
import ALoginButton from 'shared/ALoginButton'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'
import { ACTIVATOR_ID } from 'enums/activator-id'

export default {
  name: 'AHeaderActions',
  mixins: [mixins.urlGenerators, hydrationHelpers],
  components: {
    AUserIconWithModalWidget,
    ANotificationIconWithModalWidget,
    ALoginButton
  },
  consts: { REFS, ACTIVATOR_ID, BUTTON_STYLE },
  data() {
    return {
      ROUTE,
      FM_ROUTE
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: 'auth/isLoggedIn',
      isAuthFormLoadingInProgress: 'auth/isAuthFormLoadingInProgress',
      isAuthStatusRequestInProgress: 'auth/isAuthStatusRequestInProgress',
      isAuthFormLoaded: 'auth/isAuthFormLoaded',
      newNotificationCount: 'notifications/newNotificationCount'
    }),
    isUserIconVisible() {
      return this.isLoggedIn && this.isMounted
    }
  }
}
</script>

<style lang="scss" scoped>
$icon-size-lg: 30px;
$icon-size-sm: 25px;
$sign-in-btn-width: 104px;

.header-actions__wrapper {
  display: flex;
  align-items: center;
  margin-left: auto;
  flex-shrink: 0;
  min-width: $sign-in-btn-width;

  $height: (
    $above-desktop-xl: 30px,
    $mobile: auto
  );

  @include setStyleByBreakpoint('height', $height);

  .header-actions__element {
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }
  }

  .header-actions__element_sign-btn {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: left;

    @include mobile {
      width: auto;
    }

    .header-actions__sign-btn {
      height: 36px;
      width: $sign-in-btn-width;

      &.disabled {
        cursor: not-allowed;
      }
    }
  }
}
</style>
